import React, { useEffect, useContext } from "react";

import { useQuery } from "react-query";

import Wallet from "./Wallet";
import { DashboardContext } from "../../context/DashboardContext";
import { api_srv } from "../../services";
import Loader from "components/widgets/loader";
import { useHistory } from 'react-router-dom';

const WalletContainer = (props) => {
  const { accountTrans, setAccountTrans } = useContext(DashboardContext);
  const history = useHistory()

  const get_wallet_info = async () => { 
    let resp = await (await api_srv).fetch_wallet_info();
    return resp.data;
  };

  const { isLoading, isSuccess, data } = useQuery("wallet", get_wallet_info);

  console.log("wallet", data)

  async function view_account_transactions(account_number) {
    setAccountTrans([]);
    try {
      let resp = await (await api_srv).get_transactions(account_number);
      console.log("RESP", resp)
      setAccountTrans(resp.transaction);
    } catch (err) {
      let error = await err;
      console.log("error fetching account transactions", error);
      // addToast(error,{
      //   appearance: "error",
      //   autoDismiss: true,
      // });
    }
  }


  const view_wallet_details = (id) => {
   // history.push(`/dashboard/account-management/wallet/view/${id}`);
  };

  return (
    <>
      {isLoading && <Loader />}
      {isSuccess && (
        <Wallet
          wallet={data}
          target="dashboard"
          accountTrans={accountTrans}
          view_wallet_details={view_wallet_details}
          view_account_transactions={view_account_transactions}
        />
      )}
    </>
  );
};

export default WalletContainer;
